<template>
  <v-container fluid>
    <v-layout column wrap>
      <alert-filter-container :alert="alert"/>
    </v-layout>
  </v-container>
</template>

<script>
  import AlertFilterContainer from './AlertFilterContainer'
  export default {
    name: 'AlertFilterBody',
    components: {AlertFilterContainer},
    methods: {},
    computed: {
      alert () {
        return this.$store.state.admin.newSingleAlert
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertFilterBody.vue